const STORAGE_KEY = 'daps.activeTab';

export default class DAPsController {
	/* @ngInject */
	constructor($scope, $state, $stateParams, $translate) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$translate = $translate;
		this.index = 0;
	}

	$onInit() {
		const saved = localStorage.getItem(STORAGE_KEY);
		this.index = saved !== null ? parseInt(saved, 10) : 0;

		this.$scope.$watch(
			() => this.index,
			(val) => localStorage.setItem(STORAGE_KEY, val)
		);
	}
}
